import { render, staticRenderFns } from "./DangerIdentifyList.vue?vue&type=template&id=b046dbf8&scoped=true"
import script from "./DangerIdentifyList.vue?vue&type=script&lang=js"
export * from "./DangerIdentifyList.vue?vue&type=script&lang=js"
import style0 from "./DangerIdentifyList.vue?vue&type=style&index=0&id=b046dbf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b046dbf8",
  null
  
)

export default component.exports